import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User, NewPassword } from '../user';
import { UserService } from '../services/userservice.service';


@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {
  newPassword = new NewPassword();
  NewPasswordForm: string;
  token: any;

  tokens: any;
  isNew: boolean;
  message: string;
  user: any;
  isChanged = false;
  
  // UserService: any;

  constructor(private router: Router,
              private userService: UserService,
              private route: ActivatedRoute,

  ) {
    this.route.params.subscribe(

      params => {
        console.log(params);
        this.token = params.tokens;
        console.log(this.token);
      },
      error => console.log(error)
    );

  }

  ngOnInit() {

  }
  validatepwd() {
    if (this.newPassword.enterNewPassword !== this.newPassword.confirmPassword) {
      window.alert('Password Mismatch, Retype correct Password');
      document.getElementById('password').focus();
    } else {
      this.user.password = this.user.repassword;

    }
  }

  newpassword() {
    this.userService.newpassword(this.token, this.newPassword.enterNewPassword).subscribe(
      data => {
        console.log(data);
        if (data && data.status === 'Success') {
          this.isChanged = true;
          (<any> $('#session-time')).modal('show');
         
        } else {

        }
      },
      error => console.log(error)
    );
  }
  password(token: any, password: any) {
    throw new Error('Method not implemented.');
  }

}


